module.exports = __webpack_public_path__ + "img/minimize.8f2235bc.svg";